import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeRouteLegLook = 'route-leg-hop' | 'route-leg-other';

const ROUTE_LEG_LOOKS = new Set<string>(['route-leg-hop', 'route-leg-other']);
export const isWedgeRouteLegLook = (look: string): look is WedgeRouteLegLook => ROUTE_LEG_LOOKS.has(look);

/* Released leg by leg sheet (Drive, "Navigate leg by leg"): two raw buttons on each hop. The hop is a bare left-aligned flex line that fills
   the row, with a 12px by 2px padding and a 48px minimum height; its children are the caller's. The other-maps chip is a 11px semibold chip
   in the secondary ink on the elevated fill, with a 1px card border, 7px by 9px of padding, a 9px radius and a 36px minimum height. The
   platform swap in the sheet header is the Back in look of the route plan list (same declarations, checked by a test). Each reads the exact
   legacy roles, and the declaration order is the order of the source. */
const HOP_PADDING = '12px 2px', HOP_GAP = 10, HOP_HEIGHT = 48;
const OTHER_PADDING = '7px 9px', OTHER_RADIUS = 9, OTHER_HEIGHT = 36;

export function wedgeRouteLegStyle(look: WedgeRouteLegLook): CSSProperties {
  const r = wedgeExactRole;
  if (look === 'route-leg-hop') return {
    flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: HOP_GAP, padding: HOP_PADDING, background: 'none', border: 0,
    cursor: 'pointer', textAlign: 'left', minHeight: HOP_HEIGHT,
  };
  return {
    flex: '0 0 auto', background: r('bgElev'), border: `1px solid ${r('cardBorder')}`, borderRadius: OTHER_RADIUS, color: r('labelSec'),
    font: `600 11px ${r('font')}`, cursor: 'pointer', padding: OTHER_PADDING, minHeight: OTHER_HEIGHT,
  };
}

/* No look draws the transparent target: DR-3b1 measured that the anchor (position and isolation) changes the row raster, and both buttons
   sit in a hop row with a hairline between rows, where a 44px region would reach the next hop. */
export const wedgeRouteLegDrawsHit = (look: string): boolean => !isWedgeRouteLegLook(look);
